const getChartColor = (i) => {
    const colorFamily = [
        "#1793E6",
        "#19A7B8",
        "#3BB45D",
        "#D4D632",
        "#D6A632",
        "#DA8532",
        "#E56347",
        "#DC4B88",
        "#BF60C1",
        "#9660C1",
    ];
    return colorFamily[i % colorFamily.length];
};

const isMajorSector = (i, angle) => {
    return !(i > 7 || (angle + 0.5 * Math.PI) / (2 * Math.PI) > 0.7);
};

const pieLabelsDefaultOptions = {
    fontSize: 16,
    lineHeight: 18,
    fontFamily: "Roboto",
    fontWeight: "500",
    textOffset: 12,
    fontColor: "#333333",
    lineColor: "#979797",
    lineOffsetHorizontal: 30,
    lineOffsetRadial: 20,
    lineOffsetRadialThreshold: 12,
    labelFormatter: (value) => value,
    valueFormatter: (value) => value,
};

const PieLabels = {
    id: "pieLabels",
    afterDraw: (chart, arg, opt) => {
        const { ctx } = chart;
        const options = { ...pieLabelsDefaultOptions, ...opt };
        if (chart.getSortedVisibleDatasetMetas()[0] === undefined) return;
        const data = chart.getSortedVisibleDatasetMetas()[0].data;
        data.forEach((el, i) => {
            const { outerRadius: r, x, y, startAngle, endAngle } = el;
            if (!isMajorSector(i, el.$animations.startAngle._to)) return;
            const angle = (endAngle + startAngle) / 2;

            const subHeight = options.lineOffsetRadial * (angle <= Math.PI / 2 ? angle : Math.PI - angle);
            const subR =
                Math.abs(subHeight) < options.lineOffsetRadialThreshold
                    ? 0
                    : Math.sign(subHeight) * (Math.abs(subHeight) - options.lineOffsetRadialThreshold);
            const dir = angle <= Math.PI / 2 ? 1 : -1;

            const pos0 = [x + r * Math.cos(angle), y + r * Math.sin(angle)];
            const pos1 = [pos0[0] + (subR !== 0 ? subR / Math.tan(angle) : 0), pos0[1] + subR];
            const pos2 = [pos1[0] + dir * options.lineOffsetHorizontal, pos1[1]];

            ctx.strokeStyle = options.lineColor;
            ctx.beginPath();
            ctx.moveTo(pos0[0], pos0[1]);
            ctx.lineTo(pos1[0], pos1[1]);
            ctx.lineTo(pos2[0], pos2[1]);
            ctx.stroke();

            const label = chart.data.labels[i];
            const value = chart.data.datasets[0].data[i];

            if (dir < 0) ctx.textAlign = "right";
            else ctx.textAlign = "left";

            ctx.font = `${options.fontWeight} ${options.fontSize}px ${options.fontFamily}`;
            ctx.fillStyle = options.fontColor;
            ctx.fillText(options.labelFormatter(label), pos2[0] + dir * options.textOffset, pos2[1]);
            ctx.fillText(
                options.valueFormatter(value),
                pos2[0] + dir * options.textOffset,
                pos2[1] + options.lineHeight
            );
        });
    },
};

const PieLegend = {
    id: "pieLegend",
    beforeLayout: (chart, arg, opt) => {
        const chartEl = chart.canvas.parentElement.parentElement;
        if (!chartEl) return;
        let legendEl = chartEl.querySelector(".chartjs-legend");
        if (!legendEl) {
            legendEl = document.createElement("div");
            legendEl.classList.add("chartjs-legend");
            chartEl.appendChild(legendEl);
        }
        legendEl.innerHTML = chart.data.labels
            .map(
                (label, i) => `
    <div class="legend-item">
        <div class="legend-item-color" style="background-color: ${getChartColor(i)}"></div>
        <div class="legend-item-label">${label}</div>
    </div>`
            )
            .join("");
        if (opt.inside) {
            const chartContainerEl = chartEl.querySelector(".chartjs-canvas-container");
            const computedStyle = getComputedStyle(legendEl);
            const newHeight =
                chartEl.getBoundingClientRect().height -
                legendEl.getBoundingClientRect().height -
                computedStyle.marginTop.slice(0, -2) -
                computedStyle.marginBottom.slice(0, -2);
            chartContainerEl.style.height = `${newHeight}px`;
        }
    },
};

const customPieTooltip =
    ({ labelFormatter = (value) => value, valueFormatter = (value) => value }) =>
    (context) => {
        // Tooltip Element
        let chartEl = context.chart.canvas.parentElement;
        if (!chartEl || !context || !context.tooltip) return;
        let tooltipEl = chartEl.querySelector(".chartjs-tooltip");

        // Create element on first render
        if (!tooltipEl) {
            tooltipEl = document.createElement("div");
            tooltipEl.classList.add("chartjs-tooltip");
            tooltipEl.classList.add("chartjs-pie");
            chartEl.appendChild(tooltipEl);
        }

        const data = context.tooltip.dataPoints[0];
        // Hide if no tooltip
        const meta = data.element;
        const tooltipModel = context.tooltip;

        if (tooltipModel.opacity === 0 || isMajorSector(data.dataIndex, meta.$animations.startAngle._to)) {
            tooltipEl.style.opacity = "0";
            return;
        }

        tooltipEl.innerHTML = `
    <div class='tooltip-row'>
    <span class='tooltip-label-value'>${labelFormatter(data.label)}</span>
    </div>
    <div class='tooltip-row'>
    <span class='tooltip-label-value'>${valueFormatter(data.parsed)}</span>
    </div>
    `;

        const x = meta.x + meta.outerRadius * 0.7 * Math.cos((meta.startAngle + meta.endAngle) / 2);
        const y = meta.y + meta.outerRadius * 0.7 * Math.sin((meta.startAngle + meta.endAngle) / 2);
        // Display, position, and set styles for font
        tooltipEl.style.opacity = "1";
        tooltipEl.style.left = x + "px";
        tooltipEl.style.top = y + "px";
        tooltipEl.style.backgroundColor = getChartColor(data.dataIndex) + "B3";
        tooltipEl.style.transform = `translate(0, -50%)`;
    };

define(function () {
    return {
        getChartColor,
        isMajorSector,
        customPieTooltip,
        PieLabels,
        PieLegend,
    };
});
